import React from "react";
import { useTheme } from "@mui/material/styles";

const FirstStepIcon = () => {
  const theme = useTheme();
  const {
    primary: { main: primaryColor },
    secondary: { main: darkerPrimaryColor },
  } = theme.palette;
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.8903 4C33.869 4 32.2305 5.63835 32.2305 7.65985C32.2305 8.67914 32.6471 9.60119 33.3194 10.2649L27.6776 18.6274C26.8529 18.1968 25.9149 17.9534 24.9201 17.9534C22.0022 17.9534 19.5736 20.048 19.0558 22.8157L10.5114 22.0727C10.2281 20.8317 9.11764 19.9059 7.79069 19.9059C6.24927 19.9059 5 21.1552 5 22.6966C5 24.238 6.24927 25.4873 7.79069 25.4873C9.0809 25.4873 10.1664 24.612 10.486 23.4228L18.9586 24.1595C19.0417 26.2627 20.2135 28.086 21.926 29.0815L20.2945 32.8092C20.079 32.7645 19.8559 32.7411 19.6272 32.7411C17.8202 32.7411 16.3554 34.2059 16.3554 36.0129C16.3554 37.8201 17.8202 39.2848 19.6272 39.2848C21.4342 39.2848 22.899 37.8201 22.899 36.013C22.899 34.915 22.3582 33.9433 21.5284 33.3498L23.16 29.6221C23.7164 29.7937 24.3075 29.886 24.9201 29.886C26.1329 29.886 27.2612 29.5241 28.2029 28.9025L34.7175 36.7038C34.0366 37.4779 33.6236 38.4934 33.6236 39.6054C33.6236 42.0326 35.5912 44 38.0182 44C40.4454 44 42.4129 42.0326 42.4129 39.6054C42.4129 37.1782 40.4454 35.2108 38.0182 35.2108C37.1888 35.2108 36.4131 35.4405 35.7512 35.8398L29.2366 28.0385C30.2588 26.9677 30.8864 25.517 30.8864 23.9197C30.8864 22.103 30.0746 20.4761 28.7938 19.3818L34.4355 11.0194C34.8814 11.2128 35.3733 11.32 35.8903 11.32C37.9118 11.32 39.5502 9.68112 39.5502 7.65985C39.5502 5.63835 37.9117 4 35.8903 4ZM27.9078 27.4426C28.9059 26.5953 29.5392 25.3315 29.5392 23.9197C29.5392 22.3353 28.7415 20.9372 27.5259 20.1052C27.5182 20.1005 27.5106 20.0956 27.5031 20.0905C27.4953 20.0852 27.4876 20.0798 27.4801 20.0743C26.7474 19.5855 25.867 19.3006 24.9201 19.3006C22.4955 19.3006 20.5073 21.1687 20.3161 23.5441C20.3161 23.563 20.3152 23.582 20.3135 23.6012C20.3125 23.6128 20.3112 23.6244 20.3096 23.6358C20.304 23.7297 20.3011 23.8244 20.3011 23.9197C20.3011 25.8004 21.425 27.4186 23.0379 28.1391C23.048 28.143 23.0582 28.1472 23.0683 28.1516C23.0754 28.1547 23.0825 28.1579 23.0895 28.1613L23.0986 28.1657C23.6575 28.4058 24.2733 28.5388 24.9201 28.5388C26.0336 28.5388 27.0551 28.1448 27.8527 27.4886C27.8615 27.4804 27.8706 27.4725 27.8799 27.4647C27.889 27.4571 27.8983 27.4497 27.9078 27.4426Z"
        fill="url(#paint0_linear_863_39281)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_863_39281"
          x1="-5.43417"
          y1="27.659"
          x2="20.3367"
          y2="62.9744"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={darkerPrimaryColor} />
          <stop offset="0.651042" stopColor={primaryColor} />
          <stop offset="1" stopColor={primaryColor} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FirstStepIcon;
